import { createReduxAsyncThunk } from 'shared/utils';

import { brandsAPI } from 'entities/brands';

import { BRANDS_STATE } from '../../constants';

import { FavouriteBrand } from '../../types';

export const deleteFavouriteBrands = createReduxAsyncThunk<
  { favouriteBrandBillingIds: FavouriteBrand['billingId'][] },
  FavouriteBrand['billingId'][]
>(
  `${BRANDS_STATE}/deleteFavouriteBrands`,
  async (billingIds) => {
    await brandsAPI.deleteFavouriteBrands(billingIds);
    return { favouriteBrandBillingIds: billingIds };
  }
);
